module.exports = __webpack_public_path__ + "media/conversa/BannerConversa-bbc3faec.png";